@if (entity) {
  <div
    class="rootdiv w-100 p-3 flex flex-wrap justify-content-between"
    [class.modal-root]="!showSaveButton">
    <div class="ticket-header-color">
      @if (entity) {
        <div class="d-flex align-items-center flex-wrap">
          @if (entity.ticket_number_teorema) {
            <div>
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <div class="row">
                    <div class="col pr-0 pl-2 py-0">
                      <small class="">Chamado n°</small>
                    </div>
                    <div class="col-auto pr-1 pl-1 py-0 position-relative" #wrapper1>
                      <patron-button
                        customClass="py-0 pl-0"
                        variant="ghost"
                        color="secondary"
                        size="sm"
                        iconName="pi-copy"
                        (click)="ticketMenu1.toggle($event)"></patron-button>
                      <p-popover
                        [appendTo]="popoverAppendTo === null ? wrapper1 : popoverAppendTo"
                        [baseZIndex]="popoverBaseZIndex"
                        [styleClass]="popoverAppendTo === null ? 'popover-override' : ''"
                        #ticketMenu1>
                        <div class="d-flex flex-column" style="white-space: nowrap">
                          <button
                            (click)="ticketService.copyTicketNumber(entity); ticketMenu1.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar número
                          </button>
                          <button
                            (click)="copyIaContext(); ticketMenu1.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar contexto (IA)
                          </button>
                          <button
                            (click)="ticketService.copyNote(false, entity); ticketMenu1.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar recado (Privado)
                          </button>
                          <button
                            (click)="ticketService.copyNote(true, entity); ticketMenu1.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar recado (Público)
                          </button>
                        </div>
                      </p-popover>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-center text-center">
                    <b>{{
                      entity.ticket_number_teorema && entity.ticket_number_teorema.length
                        ? entity.ticket_number_teorema
                        : 'Não sincronizado'
                    }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (entity.customer_code) {
            <div>
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <!-- <small class="">Código Cliente</small> -->
                  <div class="row">
                    <div class="col pr-0 pl-2 py-0">
                      <small class="">Código Cliente</small>
                    </div>
                    <div class="col-auto pr-1 pl-1 py-0 position-relative" #wrapper2>
                      <patron-button
                        customClass="py-0 pl-0"
                        variant="ghost"
                        color="secondary"
                        size="sm"
                        iconName="pi-copy"
                        (click)="ticketMenu2.toggle($event)"></patron-button>
                      <p-popover
                        [appendTo]="popoverAppendTo === null ? wrapper2 : popoverAppendTo"
                        [baseZIndex]="popoverBaseZIndex"
                        [styleClass]="popoverAppendTo === null ? 'popover-override' : ''"
                        #ticketMenu2>
                        <div class="d-flex flex-column" style="white-space: nowrap">
                          <button
                            (click)="ticketService.copyClientCode(entity); ticketMenu2.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar código cliente
                          </button>
                          <button
                            (click)="ticketService.copyFtpPath(entity, true); ticketMenu2.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar caminho da pasta FTP (linux)
                          </button>
                          <button
                            (click)="ticketService.copyFtpPath(entity, false); ticketMenu2.hide()"
                            class="btn btn-link text-start text-decoration-none text-body p-2">
                            Copiar caminho da pasta FTP (windows)
                          </button>
                        </div>
                      </p-popover>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-center text-center">
                    <b>{{ entity.customer_code }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (entity.agent) {
            <div>
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <small class="">Agente</small>
                  <div class="d-flex align-items-center justify-content-center text-center">
                    <b>{{ entity.agent }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (entity.created_at) {
            <div class="d-none d-lg-block">
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <small class="">Criado em</small>
                  <div class="d-flex align-items-center justify-content-center text-center">
                    <b>{{ entity.created_at | date: 'dd/MM/yyyy HH:mm' }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (entity.closing_date) {
            <div class="d-none d-lg-block">
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <small class="">Fechado em</small>
                  <div class="d-flex align-items-center justify-content-center text-center">
                    <b>{{ entity.closing_date | date: 'dd/MM/yyyy HH:mm' }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (!entity.closing_date && entity.updated_at) {
            <div class="d-none d-lg-block">
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <small class="">Atualizado em</small>
                  <div class="d-flex align-items-center justify-content-center">
                    <b>{{ entity.updated_at | date: 'dd/MM/yyyy HH:mm' }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (entity.user_opened) {
            <div>
              <div class="card text-color mb-2 mr-2">
                <div class="card-body py-1 px-2">
                  <small class="">Aberto por</small>
                  <div class="d-flex align-items-center justify-content-center">
                    <b>{{ entity.user_opened.name || entity.user_opened.login }}</b>
                  </div>
                </div>
              </div>
            </div>
          }
          <!--<div *ngIf="userDes">
          <div class="card mb-2 mr-2">
            <div class="card-body py-1 px-2">
              <small class="text-muted">Desenvolvedor</small>
              <div class="d-flex align-items-center justify-content-center">
                <b>{{userDes.name || userDes.login}}</b>
              </div>
            </div>
          </div>
        </div>-->
        </div>
      }
    </div>
    <div class="flex flex-fill align-items-center justify-content-end gap-2">
      <span class="mt-2">
        <patron-badge color="info">
          <span class="d-none d-md-inline">{{ entity!!.system?.description }}</span>
          <span class="d-md-none">
            {{ entity!!.system?.description | slice: 0 : 10 }}
            @if (entity.system?.description!!.length > 10) {
              <span>..</span>
            }
          </span>
        </patron-badge>
        @if (entity.status?.description) {
          <patron-badge [color]="getStatusClass(entity.status?.description)" class="ml-1">
            <span class="d-none d-md-inline">{{ entity.status?.description }}</span>
          </patron-badge>
        }
        <patron-badge [color]="getExpectedDateColor(entity.expected_date)" class="ml-1">
          {{ (entity!!.expected_date | date: 'dd/MM/yyyy') || 'Sem previsão' }}
        </patron-badge>
      </span>
      @if (showSaveButton) {
        <div class="col-auto pr-0">
          <ts-save-button [isSaving]="isSaving" (save)="save.emit($event)"></ts-save-button>
        </div>
      }
    </div>
  </div>
}
